import { useMutation } from "@tanstack/react-query";
import { apiV1 } from "api-v2";

interface IssueCodePayload {
	token: string;
}

interface IssueCodeResponse {
	masked_email: string;
	/**
	 * ISO-8601 timestamp the issued code expires at. Optional for safety —
	 * older API builds may not include it; the FE falls back to "1 hour"
	 * copy when missing.
	 */
	verification_expires_at?: string;
	verification_required: true;
}

interface IssueCodeError {
	code?:
		| "INVITE_TOKEN_INVALID"
		| "INVITE_TOKEN_EXPIRED"
		| "VERIFICATION_LOCKED"
		| "RATE_LIMIT_EXCEEDED";
	message: string;
	status: number;
}

/**
 * Button-driven mutation that triggers the actual verification code email.
 * Heavily throttled server-side (per-token cooldown + lifetime cap). Only
 * called after the user confirms the destination email on the
 * EmailConfirmationStep — never on mount.
 */
export const useIssueVerificationCodeMutation = () =>
	useMutation<IssueCodeResponse, IssueCodeError, IssueCodePayload>({
		mutationFn: async (payload) => {
			const res = await apiV1.post<IssueCodeResponse>(
				"auth/invite/verify-link",
				payload
			);
			return res.data;
		},
		retry: false,
	});
